import { useSelector } from 'react-redux';
import { styled } from '@mui/system';
import { useTranslation } from '@hooks';
import MetricItem from './MetricItem';

const CardsWrapper = styled('div')({
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    height: 'calc(100% - 57px)',
    '@media (max-width: 375px)': {
        gridTemplateColumns: 'repeat(1, 1fr)',
    },
});

const Social = () => {
    const { t } = useTranslation();
    const { socialPosts } = useSelector(state => state.dashboard.dashboard);
    const loaded = useSelector(state => state.dashboard.loaded);

    const data = [
        {
            id: 0,
            title: t('Sidebar.socialPosts'),
            value: socialPosts.count,
            subvalue: socialPosts.countDelta,
        },
        {
            id: 2,
            title: t('AnalyticsSocialPosts.followers'),
            value: socialPosts.followers,
            subvalue: socialPosts.followersDelta,
        },
        {
            id: 3,
            title: t('AnalyticsSocialPosts.reach28'),
            value: socialPosts.reach28,
            subvalue: socialPosts.reach28Delta,
        },
    ];

    return (
        <CardsWrapper>
            {data.map(item => (
                <MetricItem
                    key={item.id}
                    value={item.value}
                    subvalue={item.subvalue}
                    title={item.title}
                    withSign={item.withSign}
                    loading={!loaded}
                />
            ))}
        </CardsWrapper>
    );
};

export default Social;
